import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  href?: string;
  className?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  href,
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3.5 text-sm font-medium tracking-widest uppercase transition-all duration-300 ease-soft';
  const variants = {
    primary: 'bg-espresso text-ivory hover:bg-taupe',
    secondary: 'bg-champagne text-espresso hover:bg-warm-beige',
    outline: 'border border-espresso text-espresso hover:bg-espresso hover:text-ivory',
    ghost: 'text-espresso hover:text-taupe relative after:absolute after:bottom-2 after:left-0 after:w-full after:h-[1px] after:bg-taupe after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:origin-left'
  };
  const classes = twMerge(baseStyles, variants[variant], className);
  if (href) {
    return <Link to={href} className={classes} data-id="element-55">
        {children}
      </Link>;
  }
  return <button className={classes} {...props} data-id="element-56">
      {children}
    </button>;
}